export default __webpack_public_path__ + "static/media/kitchen5-beforeA-2048w.f2fe572f.png";